import React from "react";

import { getDataTestId } from "../../../../utils/getDataTestId";
import {
  detachLayoutProps,
  WSElement,
  WSElementProps
} from "../../WSElement/WSElement.component";
import { WSText } from "../WSText/WSText.component";

import styles from "./WSStepper.module.scss";

export interface WSStepperProps extends WSElementProps {
  value: number;
  name?: string;
  label?: string;
  prefix?: string;
  postfix?: string;
  min?: number;
  max?: number;
  onChange(v: any): void;
}

export const WSStepper: React.FC<WSStepperProps> = (props) => {
  const {
    className,
    value,
    name,
    label,
    onChange,
    layoutProps,
    systemProps,
    postfix,
    prefix,
    min = 0,
    max = +Infinity,
    ...otherProps
  } = detachLayoutProps(props);

  const testIdBase = getDataTestId("stepper", name, label);

  return (
    <WSElement
      className={styles.wrapper}
      data-testid={testIdBase}
      {...layoutProps}
    >
      <WSElement
        role="button"
        aria-label="Decrease"
        className={styles.minus}
        data-testid={`${testIdBase}Decrement`}
        tabIndex={0}
        {...otherProps}
        onClick={() => {
          const newValue = value - 1;
          onChange?.(newValue < min ? min : newValue);
        }}
      />
      <WSText.Heading1 weight="book" className={styles.value}>
        {prefix}
        {value || min}
        {postfix}
      </WSText.Heading1>
      <WSElement
        role="button"
        aria-label="Increase"
        className={styles.plus}
        data-testid={`${testIdBase}Increment`}
        tabIndex={0}
        {...otherProps}
        onClick={() => {
          const newValue = value + 1;
          onChange?.(newValue > max ? max : newValue);
        }}
      />
    </WSElement>
  );
};
